/* unplugin-vue-components disabled */import { render } from "./exhibition.vue?vue&type=template&id=68062a9c&scoped=true"
const script = {}

import "./exhibition.vue?vue&type=style&index=0&id=68062a9c&scoped=true&lang=less"

import exportComponent from "/Users/yfy/work/work/cms-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68062a9c"]])

export default __exports__